module.exports = __webpack_public_path__ + "img/weixin.b3c0fea1.png";